import {Timer} from '@gongxigames/framework/core';
import {RealityCheckModule} from '@gongxigames/framework/slot/modules/realitycheck/RealityCheckModule';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class RealityCheckTimeState extends ModuleState<null, RealityCheckModule> {
    protected _timer?: Timer;

    onEnterState(): void {
        this.startTimer(this.module.getTime());
    }

    onLeaveState(): void {
        this.clearTimer();
    }

    protected setupEvents(): void {
    }

    protected startTimer(timeout: number): void {
        this.clearTimer();
        this._timer = this.module.updateManager.addTimer(this.goToShowingState.bind(this), timeout, true);
    }

    protected goToShowingState(): void {
        this.module.goToShowingState();
    }

    protected clearTimer(): void {
        this._timer && this._timer.stop();
        delete this._timer;
    }
}
